//? **********************************************************************
//? * Original URL ID Guard
//? ***********************************************************************

//? **********************************************************************
//? * Imports
//? **********************************************************************
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { secureStorage } from '../data-access/services/localstorage.service';

//? **********************************************************************
//? * Guard
//? **********************************************************************

@Injectable({
  providedIn: 'root',
})
export class OriginalIdGuard implements CanActivate {

  //* Constructor para inyectar el router
  constructor(private router: Router) {}

  //* Método para activar la ruta
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentId = route.queryParams['id'];
    const originalId = secureStorage.getSessionItem('originalCuestionarioPandoId');

    if (!originalId) {
      // Primera carga, guardar el ID
      secureStorage.setSessionItem('originalCuestionarioPandoId', currentId);
      return true;
    }

    if (currentId === originalId) {
      return true;
    }

    // Construir la URL correcta manteniendo la ruta base
    const baseUrl = state.url.split('?')[0];
    const queryParams = { ...route.queryParams, id: originalId };

    // Navegar manteniendo la estructura de la URL
    this.router.navigate([baseUrl], {
      queryParams: queryParams,
      replaceUrl: true,
      queryParamsHandling: 'merge'
    });

    return false;
  }
}
